import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'portalescola',
      storage,
      whitelist: ['auth', 'professor', 'unidade'],
    },
    reducers
  );

  return persistedReducer;
};
